export default __webpack_public_path__ + "static/media/Logo.3027fe78.png";